var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNnw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.333008 16.833H7.08301L11.41634 22.4997V16.833H14.333V27.4997H11.83301L7.24967 21.6663V27.4997H4.333008V16.833z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.833H19L23.4167 22.4997V16.833H26.3333V27.4997H23.75L19.1667 21.6663V27.4997H16.25V16.833z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.583 16.8333H30.6663L32.4997 23L34.583 16.75H37.1663L39.2497 23L41.083 16.8333H44.1663L40.583 27.5833H37.9997L35.833 21.4167L33.6663 27.5833H31.083L27.583 16.8333z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 13.5833C7.08333 11.9167 7.08333 10.25 7.25 8.66667C10.66667 8.66667 18.6667 8.25 24.0833 4.16667C26.1667 5.66667 31.3333 8.5 40.6667 8.58333C40.75 9.66667 40.8333 11.4167 40.8333 13.5833H44C44 9.66667 43.6667 7 43.5833 6.83333L43.4167 5.5H42C41.75 5.5 41.5 5.5 41.25 5.5C29.75 5.5 25.1667 1.08333 25.0833 1.08333L24.0833 0L23 1C17.4167 6.16667 6.08333 5.5 5.91667 5.5L4.333333 5.41667L4.25 6.91667C4.0833333 9.25 4 11.4167 4 13.5833H7.08333z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1667 30.7503C35.4167 38.167 30.6667 42.917 23.9167 44.8337C22.8333 44.5837 18.8333 43.5837 15 39.5003C12.66667 37.0003 11 34.0003 9.75 30.7503H6.5C7.91667 35.0837 10 38.667 12.75 41.5837C18 47.167 23.5833 47.917 23.8333 47.917H24.1667L24.5 47.8337C32.6667 45.5837 38.4167 39.7503 41.5 30.667H38.1667V30.7503z",
    fill: "#182F88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNnw);
export default __webpack_public_path__ + "static/media/nnw.4b6604d0.svg";
export { ForwardRef as ReactComponent };